module.exports = __webpack_public_path__ + "static/media/iconPassword.9fb4cff4.svg";